import PropTypes from 'prop-types';

const Channel_partners = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-4 bg-primary-950'}>
      <div className={'max-w-6xl p-4 w-full '}>
        <h1 className={'playfair-display-medium font-bold lg:text-6xl text-3xl mb-4 text-secondary-300'}>Our Channel Partners</h1>
        <h1 className={'playfair-display-medium font-semibold lg:text-2xl text-xl mb-4 text-secondary-300'}> We collaborate with trusted brands to ensure performance, durability, and warranty-backed peace of mind.</h1>
        <div className={'flex flex-wrap justify-center lg:gap-5 gap-3 bg-primary-300 lg:px-10 px-2 lg:py-10 py-6  rounded-3xl'}>
          {data[0]?.images?.map((image, index) => (
            <div key={index} className={'h-32'}>
              <img src={image} alt={'Channel Partner'} className={'w-full h-full rounded-lg'} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Channel_partners.propTypes = {
  data: PropTypes.array,
};

export default Channel_partners;
